"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GTMEvent {
    constructor(name, data, callback) {
        this.trackedTimestamp = 0;
        this.tracked = false;
        this.track = () => {
            if (this.tracked) {
                return false;
            }
            const timestamp = new Date().getTime();
            this.trackedTimestamp = timestamp;
            // Check if window.dataLayer exists
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign(Object.assign({}, this.data), { event: this.name, event_created: this.timestamp, event_tracked: timestamp }));
            this.tracked = true;
            if (typeof this.callback === "function") {
                this.callback();
            }
            return true;
        };
        this.name = name;
        this.data = data;
        this.timestamp = new Date().getTime();
        if (typeof callback === "function") {
            this.callback = callback;
        }
    }
}
exports.default = GTMEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZXZlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxRQUFRO0lBUVYsWUFBWSxJQUFZLEVBQUUsSUFBWSxFQUFFLFFBQXFCO1FBSHRELHFCQUFnQixHQUFHLENBQUMsQ0FBQztRQUNyQixZQUFPLEdBQUcsS0FBSyxDQUFDO1FBWWhCLFVBQUssR0FBRyxHQUFHLEVBQUU7WUFDaEIsSUFBSSxJQUFJLENBQUMsT0FBTyxFQUFFO2dCQUNkLE9BQU8sS0FBSyxDQUFDO2FBQ2hCO1lBRUQsTUFBTSxTQUFTLEdBQUcsSUFBSSxJQUFJLEVBQUUsQ0FBQyxPQUFPLEVBQUUsQ0FBQztZQUN2QyxJQUFJLENBQUMsZ0JBQWdCLEdBQUcsU0FBUyxDQUFDO1lBRWxDLG1DQUFtQztZQUNuQyxNQUFNLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxTQUFTLElBQUksRUFBRSxDQUFDO1lBQzFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBSSxpQ0FDZCxJQUFJLENBQUMsSUFBSSxLQUNaLEtBQUssRUFBRSxJQUFJLENBQUMsSUFBSSxFQUNoQixhQUFhLEVBQUUsSUFBSSxDQUFDLFNBQVMsRUFDN0IsYUFBYSxFQUFFLFNBQVMsSUFDMUIsQ0FBQztZQUVILElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO1lBQ3BCLElBQUksT0FBTyxJQUFJLENBQUMsUUFBUSxLQUFLLFVBQVUsRUFBRTtnQkFDckMsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFDO2FBQ25CO1lBRUQsT0FBTyxJQUFJLENBQUM7UUFDaEIsQ0FBQyxDQUFDO1FBaENFLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxJQUFJLEVBQUUsQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUV0QyxJQUFJLE9BQU8sUUFBUSxLQUFLLFVBQVUsRUFBRTtZQUNoQyxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztTQUM1QjtJQUNMLENBQUM7Q0EwQko7QUFFRCxrQkFBZSxRQUFRLENBQUMifQ==